import React from 'react'

const Header=()=>{
    return(
        <React.Fragment>
        <h2 className="text-center">Todo App</h2>
        <hr/>
        </React.Fragment>
    )
}

export default Header